import { Injectable, Input } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  @Input() filePath!: string;
  constructor(private storage: AngularFireStorage) {}

  uploadFile(
    file: File,
    path: string
  ): Observable<{ url: string; progress: number }> {
    const filePath = `${path}/${Date.now()}_${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    const uploadData = new Subject<{ url: string; progress: number }>();

    task.percentageChanges().subscribe((progress) => {
      uploadData.next({ url: '', progress: progress || 0 });
    });

    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe((url) => {
            uploadData.next({ url: url, progress: 100 });
            uploadData.complete();
          });
        })
      )
      .subscribe();

    return uploadData.asObservable();
  }
}
